import React, {useCallback, useMemo, useState} from 'react';
import {getMappedValue, setMappedValue} from "./mappings";
import uniqBy from "lodash/uniqBy";

export const ModelContext = React.createContext({});

export function ModelSource({data, dataIssues, locked, children}) {

  const [modifications, setState] = useState(0);
  const [notifications, setNotifications] = useState([])
  function modification() {
    setState(modifications => modifications + 1);
  }

  const setValues = values => {
    Object.keys(values).forEach(key => {
      setMappedValue(data, key, values[key]);
    });
    modification();
  };

  const setValue = (path, value) => {
    setMappedValue(data, path, value);
    modification();
  };


  const getValue = path => {
    return getMappedValue(data, path);
  };

  const notify = (notificationConfig) => {
    if(!notificationConfig.id){
      console.warn("Notification configurations require an 'id' property");
      return;
    }
    setNotifications(uniqBy([notificationConfig, ...notifications], 'id'))
    if(notificationConfig.timeout) {
      setTimeout(() => {
        setNotifications(notifications.filter(n => n.id !== notificationConfig.id))
      }, notificationConfig.timeout)
    }
  }


  const model = useMemo(() => ({
    setValues, setValue, getValue, modification, data, dataIssues, locked, notifications, notify
  }), [modifications, data, dataIssues, locked, notifications, notify]);

  return <ModelContext.Provider value={model}>
    {children}
  </ModelContext.Provider>;

}